import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import PageLoading from "components/shared/PageLoading";
import { useDispatch } from "react-redux";
import LinkPreview, { Link } from "components/chat/shared/LinkPreview";
import classNames from "classnames";

type LinkAttachmentPreviewArgs = {
  link: Link;
  chatId: string;
  showCrawlerError: boolean;
};

export default function LinkAttachmentPreview({
  link,
  chatId,
  showCrawlerError,
}: LinkAttachmentPreviewArgs) {
  const dispatch = useDispatch();

  function removeLinkPreview() {
    dispatch({
      type: "chat/COMPOSER/ADD_LINK_ATTACHMENT",
      chatId,
      linkAttachment: { ...link, show: false },
    });
  }

  return (
    <div className="bg-white rounded">
      {link.loading ? (
        <div className="p-3">
          <PageLoading />
        </div>
      ) : showCrawlerError && !link ? (
        <span className="p-3 text-danger">
          {I18n.t("js.chat.attachments.links.crawl_error")}
        </span>
      ) : (
        <div
          className={classNames("grid items-center", {
            "grid-cols-[auto_1fr_auto]": !!link.image_url,
            "grid-cols-[1fr_auto]": !link.image_url,
          })}
        >
          <LinkPreview link={link} />
          <button
            className="btn btn-sm text-muted self-start"
            role="button"
            onClick={removeLinkPreview}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      )}
    </div>
  );
}
